<template>
  <div class="container">
    <Layout :key="Number(modulo)" />
    <br />
    <Welcome v-model:show="showWelcome" v-if="modulo === 0" />
    <br />
    <div class="card-container" v-if="modulo === 0">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100;
        "
      >
        <div class="card-group">
          <div
            class="card"
            @click="modulo_seleccionado(1)"
            v-if="moduloAdministracion === 1"
            style="width: 250px"
          >
            <img
              src="../assets/administracion.png"
              class="card-img-top"
              alt="..."
              style="
                display: block;
                margin: auto;
                width: 200px;
                height: 200px;
                object-fit: cover;
              "
            />
            <div class="card-body">
              <h5 class="card-title text-center">Administración</h5>
            </div>
          </div>
        </div>
        <div class="card-group">
          <div
            class="card"
            @click="modulo_seleccionado(5)"
            v-if="moduloAuditoria === 1"
            style="width: 250px"
          >
            <img
              src="../assets/images/acfss.png"
              class="card-img-top"
              alt="..."
              style="
                display: block;
                margin: auto;
                width: 200px;
                height: 200px;
                object-fit: cover;
              "
            />
            <div class="card-body">
              <h5 class="card-title text-center">AlliKamay</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />	
    <tips v-if="modulo === 0"></tips>
    <div v-if="modulo === 1" class="card-group" style="display: flex; flex-direction: column; align-items: center">
      <div>
        <img
          src="../assets/administracion.png"
          class="card-img-top"
          alt="..."
          style="width: 400px; height: 400px; object-fit: cover"
        />
        <div class="card-body">
          <h5 class="card-title">Administración</h5>
        </div>
      </div>
    </div>
    <div class="card-group" v-if="modulo === 5">
      <div
        v-for="opcion in opcionesFiltradas"
        :key="opcion.id"
        class="card"
        :class="{ 'espacioPrestador': esPrestador }"
        @click="navegar(opcion.ruta)"
      >
        <img
          :src="opcion.imagen"
          alt="Imagen de la opción"
          class="card-img-top"
          style="width: 100px; height: 100px; object-fit: cover; margin: auto"
        />
        <div class="card-body">
          <h5 class="card-title">{{ opcion.titulo }}</h5>
          <p class="card-text">{{ opcion.descripcion }}</p>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
    <div class="estilo-destacado" v-if="modulo != 0">
      Para explorar y acceder a las demás opciones del módulo, por favor utilice
      el menú lateral izquierdo.
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import Tips from "@/components/Tips.vue";
import Welcome from "@/components/Welcome.vue";

export default {
  data() {
    return {
      moduloAdministracion: 0,
      moduloAuditoria: 0,
      usuario: "",
      modulo: 0,
      showWelcome: true,
      p_idPerfil: 0,
      opcionesPrestador: [
        {
          id: 1,
          titulo: "Trámites",
          descripcion: "Acceso a la gestión de trámites.",
          ruta: "/tramite-carga",
          imagen: require("@/assets/images/tramites.png"),
        },
      ],
      opcionesPrestadorObs: [
        {
          id: 1,
          titulo: "Trámites",
          descripcion: "Acceso a las observaciones de los trámites.",
          ruta: "/tramite-consulta",
          imagen: require("@/assets/images/tramites.png"),
        },
      ],
      opcionesACFSS: [
        {
          id: 1,
          titulo: "Trámites",
          descripcion: "Explora todos los trámites disponibles y realiza nuevas gestiones.",
          ruta: "/tramite",
          imagen: require("@/assets/images/tramites.png"),
        },
        {
          id: 2,
          titulo: "Trámites Asignados",
          descripcion: "Consulta y gestiona los trámites que te han sido asignados para revisión o acción.",
          ruta: "/tramite-asignados",
          imagen: require("@/assets/images/tramites_asignados.png"),
        },
        {
          id: 3,
          titulo: "Trámites Procesados",
          descripcion: "Visualiza el historial de trámites ya revisados o completados en el sistema.",
          ruta: "/tramite-procesados",
          imagen: require("@/assets/images/tramites_procesados.png"),
        },
      ],
    };
  },
  components: {
    Layout,
    Footer,
    Tips,
    Welcome,
  },
  computed: {
    opcionesFiltradasACFSS() {
      const puedeVerAdicionales = [1, 17, 19].includes(this.p_idPerfil);
      return this.opcionesACFSS.filter((opcion) => {
        return (
          opcion.id === 2 ||
          (puedeVerAdicionales && (opcion.id === 1 || opcion.id === 3))
        );
      });
    },
    opcionesFiltradas() {
      const perfil = Number(this.p_idPerfil);
      if (perfil === 15) return this.opcionesPrestador;
      if (perfil === 21) return this.opcionesPrestadorObs;
      return this.opcionesFiltradasACFSS;
    },
  },
  async mounted() {
    //    this.p_idPerfil = window.sessionStorage.getItem("idPerfil");
    this.p_idPerfil           = parseInt(window.sessionStorage.getItem("idPerfil"), 10) || 0;
    this.moduloAdministracion = parseInt(window.sessionStorage.getItem("moduloAdministracion"), 10) || 0;
    this.moduloAuditoria      = parseInt(window.sessionStorage.getItem("moduloAuditoria"), 10) || 0;
    const idEmpresa = Number(window.sessionStorage.getItem("idEmpresa"));
    if (idEmpresa === 1) {
      this.$router.push("/seleccion-empresa");
      return;
    }
    await this.authorization();
    //    alert("Menú Principal - mounted: "+window.sessionStorage.getItem("modulo"));
  },
  methods: {
    navegar(ruta) {
      this.$router.push(ruta);
    },
    async authorization() {
      this.usuario = window.sessionStorage.getItem("usuario");
    },
    async modulo_seleccionado(p_modulo) {
      this.modulo = p_modulo; // p_modulo ya es un número (1 o 5)
      window.sessionStorage.setItem("modulo", String(this.modulo));
      this.$router.push("/MenuPrincipal");
    },
    esPrestador() {
      return Number(this.p_idPerfil) === 15;
    },
  },
};
</script>
<style scoped>
.card-container {
  display: flex;
  flex-wrap: wrap; /* Permite la envoltura de tarjetas */
  justify-content: space-around; /* Espaciado uniforme */
  padding: 20px;
}

.card {
  width: 300px; /* Ancho fijo para todas las tarjetas */
  border-radius: 10px; /* Bordes redondeados */
  overflow: hidden; /* Oculta cualquier contenido que se desborde */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra suave */
  cursor: pointer;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease;
}

.card:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0px 0px 10px 2px rgb(253, 209, 13);
  transform: translateY(-5px);
}

.card-body {
  padding: 20px;
  background: linear-gradient(
    145deg,
    #ffffff,
    #f0f0f0
  ); /* Gradiente de fondo */
  display: flex;
  flex-direction: column;
  align-items: center; /* Centrado vertical de texto e imágenes */
  gap: 10px; /* Espacio entre elementos dentro de la tarjeta */
}

.card-title {
  font-size: 20px; /* Tamaño de fuente más grande para el título */
  color: #0056b3; /* Un color distintivo para los títulos */
  font-weight: 600; /* Fuente en negrita */
}

.card-text {
  font-size: 16px; /* Tamaño de fuente para el texto descriptivo */
  color: #333; /* Color oscuro para texto, mejor legibilidad */
  text-align: center; /* Alineación del texto */
}

.estilo-destacado {
  background-color: #4caf50; /* Fondo verde */
  color: white; /* Texto blanco */
  padding: 15px; /* Espacio interior */
  border-radius: 8px; /* Bordes redondeados */
  font-size: 18px; /* Tamaño de fuente más grande */
  text-align: center; /* Centrado del texto */
  margin: 10px 0; /* Margen superior e inferior para separarlo de otros elementos */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra suave para resaltar */
}

.espacioPrestador {
  width: 30%;
  max-width: 350px;
  min-width: 280px;
  margin: 0 auto;
}

</style>
